import { enableProdMode } from '@angular/core';
import { platformBrowserDynamic } from '@angular/platform-browser-dynamic';
import { CaptureConsole as CaptureConsoleIntegration } from '@sentry/integrations';
import { AppModule } from './app/app.module';
import { environment } from './environments/environment';
import * as Sentry from '@sentry/angular-ivy';
import { Endpoints } from '@huge-monorepo/portal/config';

let SENTRY_CONFIG: any = {};
let v = new Endpoints(environment);

SENTRY_CONFIG = {
  Environment: environment.production ? 'PRODUCTION' : 'DEVELOPMENT',
  Production: environment.production,
  DSN: environment.dsn,
  Enabled: environment.dsn != '',
  TracesSampleRate: environment.tracesSampleRate,
  Debug: environment.production ? false : true,
  Version: v.APP_VERSION,
};

if (SENTRY_CONFIG.Production) {
  enableProdMode();
}
Sentry.init({
  dsn: SENTRY_CONFIG.DSN,
  integrations: [
    new Sentry.BrowserTracing(),
    new CaptureConsoleIntegration({
      levels: ['error'],
    }),
  ],
  environment: SENTRY_CONFIG.Environment,
  enabled: SENTRY_CONFIG.Enabled,
  tracesSampleRate: SENTRY_CONFIG.TracesSampleRate,
  debug: SENTRY_CONFIG.Debug,
  release: 'huge-customer-portal@' + SENTRY_CONFIG.version,
});

platformBrowserDynamic()
  .bootstrapModule(AppModule)
  .catch((err) => console.log(err));
